module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8eiPV"))).then(() => parcelRequire('fThBo'));